import styled from "styled-components";

export const Wrapper = styled.section`
  width: 100%;
  border-radius: 5px 5px 0px 0px;
  box-shadow: 0px 1px 1px 1px #e5e5e5;
  margin: 0 0 12px 0;
`;

export const ColumnsRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr 1fr 1fr"};
  gap: 1rem;
  padding: 12px 16px;
  background: #fff;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Block = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  overflow: hidden;
  height: fit-content;
`;

export const BlockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: ${(props) => (props.$isSelected ? "#1b3a63" : "#767676")};
  color: #fff;
  font-family: Lato;
  font-weight: 700;
  font-size: 15px;
`;

export const CrossIcon = styled.span`
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #fff;
  &:hover {
    opacity: 0.8;
  }
`;

export const BlockBody = styled.div`
  padding: 12px;
  min-height: 70px;
  background: #fff;
`;

export const InfoLine = styled.div`
  font-family: Lato;
  font-size: 15px;
  color: #474747;
  margin-bottom: 6px;
  line-height: 1.4;
`;

export const InfoLabel = styled.span`
  font-weight: 700;
  color: #474747;
`;

export const WarningText = styled.div`
  font-family: Lato;
  font-size: 13px;
  font-weight: 700;
  color: #ff9800;
  margin-top: 8px;
`;

export const PlaceholderText = styled.div`
  font-family: Lato;
  font-size: 13px;
  font-style: italic;
  color: #767676;
  margin-top: 8px;
`;

export const RecipientsOuter = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background: #fff;
  padding: 10px;
  max-height: 260px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cfcfcf;
    border-radius: 3px;
  }
`;

export const RecipientCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid ${(props) => (props.$isSelected ? "#32a728" : "#e5e5e5")};
  background: ${(props) => (props.$isSelected ? "#ebf6ea" : "#fff")};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RecipientInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RecipientName = styled.span`
  font-family: Lato;
  font-size: 15px;
  font-weight: 700;
  color: #474747;
`;

export const RecipientEmail = styled.span`
  font-family: Lato;
  font-size: 15px;
  color: #15aee5;
`;

export const RecipientNoEmail = styled.span`
  font-family: Lato;
  font-size: 15px;
  font-style: italic;
  color: #767676;
`;
